module.exports = __webpack_public_path__ + "static/img/consult3.1b8ece55.png";